import { useNavigate } from "react-router-dom"

const Button = (data: any) => {
    const navigate = useNavigate()
    const scrollToTop = () => window.scrollTo({top: 0, behavior: "smooth"})
    const locate = () => {
        navigate(data.route, { state: data.page || "" })
        scrollToTop();
    }
    return (
        <button className={!!data?.disabled ? `button button-disabled`: `button ${data?.override}`} onClick={data.onClick ? data.onClick: locate } disabled={!!data?.disabled}>
            {data.text}
        </button>
    )
}

export default Button
